import { CreatedInterfaces } from 'interfaces';
import { usePostRequest } from './utils/usePostRequest';

interface UseCreateNewCardStateResult {
  cardState: any;
  createCardState: any;
  isLoading: boolean;
  isError: unknown;
}
interface UseCreateNewCardState {
  (cardId: string, state: string, reason: string): UseCreateNewCardStateResult;
}

const useCreateNewCardState: UseCreateNewCardState = (cardId, state, reason) => {
  const resource = 'card-';
  const path = `v1/cards/${cardId}/transitions`;

  const [{ data, error, loading }, createData] = usePostRequest<CreatedInterfaces<typeof resource>>({
    path,
  });

  return {
    cardState: data,
    createCardState: () => createData({ state, reason }),
    isLoading: loading,
    isError: error,
  };
};

export default useCreateNewCardState;
